import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import {
  FiSave, FiSettings, FiEye, FiEyeOff, FiMail, FiPhone,
  FiMapPin, FiCamera, FiUser, FiLock, FiFileText, FiBell,
} from "react-icons/fi";
import {
  FaStore, FaUniversity, FaEdit, FaTrash, FaPlus, FaTimes,
  FaClock, FaUpload, FaBuilding, FaPhone, FaIdCard, FaLock,
  FaCheckCircle, FaFileAlt,
} from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "../../../components/general/button/Button";
import Pagination from "../../../components/general/pagination/Pagination";
import "../../../assets/css/seller/settings/SellerSettings.css";
import SellerLayout from "../../../layouts/SellerLayout";
import MyContext from "../../../context/MyContext";
import { SellerSettingsPageSkeleton } from "../../../components/general/skeleton/SkeletonBlock";

const errBorder = { borderColor: "#dc3545" };
const errText = { color: "#dc3545", fontSize: 12, marginTop: 4, marginBottom: 0 };

const SellerSettings = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken, baseUrlForFiles, regExpChecker } = useContext(MyContext);

  const [activeTab, setActiveTab] = useState("shop-profile");
  const [showBankForm, setShowBankForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [sellerName, setSellerName] = useState("");
  const [sellerEmail, setSellerEmail] = useState("");
  const [shop_name, setshop_name] = useState("");
  const [sellerPhone, setSellerPhone] = useState("");
  const [sellerDescription, setSellerDescription] = useState("");
  const [businessDetailsId, setBusinessDetailsId] = useState(null);
  const [logo, setLogo] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [cnic, setCnic] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [businessemail, setBusinessemail] = useState("");

  const [businessemailError, setBusinessemailError] = useState("");
  const [phonenumberError, setPhonenumberError] = useState("");
  const [businessAddressError, setBusinessAddressError] = useState("");

  const [sellerNameError, setSellerNameError] = useState("");
  const [sellerEmailError, setSellerEmailError] = useState("");
  const [sellerPhoneError, setSellerPhoneError] = useState("");

  const [documents, setDocuments] = useState(null);
  const [kycFileName, setKycFileName] = useState("");
  const [kycFileSize, setKycFileSize] = useState("");
  const [isVerified, setIsVerified] = useState("pending");

  const [kycPhoneError, setKycPhoneError] = useState("");
  const [kycCnicError, setKycCnicError] = useState("");
  const [kycAddressError, setKycAddressError] = useState("");
  const [kycDocumentsError, setKycDocumentsError] = useState("");

  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankName, setBankName] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [isPrimary, setIsPrimary] = useState(false);

  const [bankNameError, setBankNameError] = useState("");
  const [accountTitleError, setAccountTitleError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePass = (key) => {
    if (key === "current") setShowCurrentPassword((p) => !p);
    else if (key === "new") setShowNewPassword((p) => !p);
    else if (key === "confirm") setShowConfirmPassword((p) => !p);
  };

  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  // ── Notification Preferences States (naye) ──
  const [emailNotification, setEmailNotification] = useState(true);
  const [inAppNotification, setInAppNotification] = useState(true);
  const [savingPreferences, setSavingPreferences] = useState(false);

  const tabs = [
    { id: "shop-profile", label: "Shop Profile", icon: <FaStore /> },
    { id: "personal-info", label: "Personal Information", icon: <FiUser /> },
    { id: "bank-accounts", label: "Bank Accounts", icon: <FaUniversity /> },
    { id: "password", label: "Change Password", icon: <FiLock /> },
    { id: "verification", label: "KYC Verification", icon: <FiFileText /> },
    { id: "notifications", label: "Notifications", icon: <FiBell /> },
  ];

  // ════════════════════════════════
  // API: viewSellerProfile — GET + Bearer, no kmseller_id
  // ════════════════════════════════
  const viewSellerProfile = () => {
    setPageLoading(true);
    axios
      .post(`${baseUrl}/seller/profile/viewProfile`, {}, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.error) {
          Swal.fire({ icon: "error", title: "Error", text: data.error });
        } else {
          const s = data.seller;
          setSellerName(s.name);
          setSellerEmail(s.email);
          setshop_name(s.shop_name);
          setSellerPhone(s.phone);
          setSellerDescription(s.description);
          setEmailNotification(s.emailNotification == 1);
          setInAppNotification(s.inAppNotification == 1);
          if (s.kmbusinessdetail) {
            const bd = s.kmbusinessdetail;
            setBusinessDetailsId(bd.id);
            setLogoPreview(bd.logo ? `${baseUrlForFiles}/${bd.logo}` : "");
            setPhonenumber(bd.phonenumber);
            setCnic(bd.cnic);
            setBusinessAddress(bd.address);
            setBusinessemail(bd.businessemail);
          }
          if (s.kmkyc) setIsVerified(s.kmkyc.isVerified || "pending");
        }
        setPageLoading(false);
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Error", text: "Failed to load profile." });
        setPageLoading(false);
      });
  };

  useEffect(() => {
    if (!authToken) {
      setLoading(false);
      navigate("/seller/login");
      return;
    }
    viewSellerProfile();
  }, [authToken]);

  const validateShopProfile = () => {
    let valid = true;

    const emailErr = regExpChecker("email", businessemail);
    if (!businessemail) {
      setBusinessemailError("Business email is required");
      valid = false;
    } else if (emailErr) {
      setBusinessemailError(emailErr);
      valid = false;
    } else setBusinessemailError("");

    if (phonenumber) {
      const phoneErr = regExpChecker("phoneNumber", phonenumber);
      if (phoneErr) {
        setPhonenumberError(phoneErr);
        valid = false;
      } else setPhonenumberError("");
    } else setPhonenumberError("");

    if (!businessAddress?.trim()) {
      setBusinessAddressError("Business address is required");
      valid = false;
    } else setBusinessAddressError("");

    return valid;
  };

  // ════════════════════════════════
  // API: addBusinessDetails — Bearer added
  // ════════════════════════════════
  const addBusinessDetails = () => {
    if (!validateShopProfile()) return;

    setLoading(true);
    const fd = new FormData();
    fd.append("phonenumber", phonenumber);
    fd.append("cnic", cnic);
    fd.append("address", businessAddress);
    fd.append("businessemail", businessemail);
    if (logo) fd.append("logo", logo);
    axios
      .post(`${baseUrl}/seller/businessdetails/addBusinessDetails`, fd, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        setLoading(false);
        if (data.success) {
          Swal.fire("Saved!", "Business details added successfully", "success");
          if (data.id) setBusinessDetailsId(data.id);
          viewSellerProfile();
        } else Swal.fire("Error!", data.message, "error");
      })
      .catch(() => {
        setLoading(false);
        Swal.fire("Error!", "Failed to add business details", "error");
      });
  };

  // ════════════════════════════════
  // API: updateBusinessDetails — Bearer added
  // ════════════════════════════════
  const updateBusinessDetails = () => {
    if (!validateShopProfile()) return;

    setLoading(true);
    const fd = new FormData();
    fd.append("id", businessDetailsId);
    fd.append("phonenumber", phonenumber);
    fd.append("cnic", cnic);
    fd.append("address", businessAddress);
    fd.append("businessemail", businessemail);
    if (logo) fd.append("logo", logo);
    axios
      .post(`${baseUrl}/seller/businessdetails/updateBusinessDetails`, fd, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        setLoading(false);
        if (data.success) {
          Swal.fire("Saved!", "Business details updated successfully", "success");
          viewSellerProfile();
        } else Swal.fire("Error!", data.message, "error");
      })
      .catch(() => {
        setLoading(false);
        Swal.fire("Error!", "Failed to update business details", "error");
      });
  };

  const validateKyc = () => {
    let valid = true;

    if (phonenumber) {
      const phoneErr = regExpChecker("phoneNumber", phonenumber);
      if (phoneErr) {
        setKycPhoneError(phoneErr);
        valid = false;
      } else setKycPhoneError("");
    } else {
      setKycPhoneError("Phone number is required");
      valid = false;
    }

    if (cnic) {
      const cnicErr = regExpChecker("CNICnumber", cnic);
      if (cnicErr) {
        setKycCnicError(cnicErr);
        valid = false;
      } else setKycCnicError("");
    } else {
      setKycCnicError("CNIC number is required");
      valid = false;
    }

    if (!businessAddress?.trim()) {
      setKycAddressError("Business address is required");
      valid = false;
    } else setKycAddressError("");

    if (!documents) {
      setKycDocumentsError("Please upload your KYC document PDF");
      valid = false;
    } else setKycDocumentsError("");

    return valid;
  };

  // ════════════════════════════════
  // API: uploadKycDocuments — Bearer added
  // ════════════════════════════════
  const uploadKycDocuments = () => {
    if (!validateKyc()) return;

    setLoading(true);
    const fd = new FormData();
    fd.append("shop_name", shop_name);
    fd.append("phonenumber", phonenumber);
    fd.append("cnic", cnic);
    fd.append("address", businessAddress);
    fd.append("businessemail", businessemail);
    fd.append("documents", documents);
    axios
      .post(`${baseUrl}/seller/kyc/uploadKycDocuments`, fd, {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        setLoading(false);
        if (data.success) {
          setIsVerified("pending");
          Swal.fire({
            title: "Submitted!",
            icon: "success",
            text: "KYC verification submitted successfully",
            confirmButtonColor: "#097d43",
          });
          viewSellerProfile();
        } else Swal.fire("Error!", data.message, "error");
      })
      .catch(() => {
        setLoading(false);
        Swal.fire("Error!", "Failed to upload KYC documents", "error");
      });
  };

  // ════════════════════════════════
  // API: fetchBankAccounts — GET + Bearer, no kmseller_id
  // ════════════════════════════════
  const fetchBankAccounts = () => {
    if (!authToken) return;
    axios
      .get(`${baseUrl}/seller/bank/viewAllBankAccounts`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.hasOwnProperty("error")) {
          Swal.fire("Error!", data.error, "error");
        } else if (data.success == true) {
          setBankAccounts(data.accounts);
        }
      });
  };

  useEffect(() => {
    fetchBankAccounts();
  }, [authToken]);

  const validateBankForm = () => {
    let valid = true;

    if (!bankName) {
      setBankNameError("Please select a bank");
      valid = false;
    } else setBankNameError("");

    if (!accountTitle?.trim()) {
      setAccountTitleError("Account title is required");
      valid = false;
    } else setAccountTitleError("");

    if (!accountNumber?.trim()) {
      setAccountNumberError("Account number is required");
      valid = false;
    } else if (!/^[0-9]{5,}$/.test(accountNumber.trim())) {
      setAccountNumberError("Account number must be at least 5 digits");
      valid = false;
    } else setAccountNumberError("");

    return valid;
  };

  // ════════════════════════════════
  // API: addBankAccount — Bearer added, no kmseller_id
  // ════════════════════════════════
  const addBankAccount = () => {
    if (!validateBankForm()) return;
    const formData = new FormData();
    formData.append("bankname", bankName);
    formData.append("accounttitle", accountTitle);
    formData.append("accountnumber", accountNumber);
    formData.append("isprimary", isPrimary ? 1 : 0);
    axios
      .post(`${baseUrl}/seller/bank/addBankAccount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.hasOwnProperty("error")) {
          Swal.fire("Error!", data.error, "error");
        } else if (data.success == true) {
          fetchBankAccounts();
          Swal.fire("Added!", "Bank account added", "success");
          setShowBankForm(false);
          setSelectedBank(null);
        } else {
          Swal.fire("Error!", data.message, "error");
        }
      });
  };

  // ════════════════════════════════
  // API: updateBankAccount — Bearer added
  // ════════════════════════════════
  const updateBankAccount = () => {
    if (!validateBankForm()) return;
    const formData = new FormData();
    formData.append("id", selectedBank.id);
    formData.append("bankname", bankName);
    formData.append("accounttitle", accountTitle);
    formData.append("accountnumber", accountNumber);
    formData.append("isprimary", isPrimary ? 1 : 0);
    axios
      .post(`${baseUrl}/seller/bank/updateBankAccount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.hasOwnProperty("error")) {
          Swal.fire("Error!", data.error, "error");
        } else if (data.success == true) {
          fetchBankAccounts();
          Swal.fire("Updated!", "Bank account updated", "success");
          setShowBankForm(false);
          setSelectedBank(null);
        } else {
          Swal.fire("Error!", data.message, "error");
        }
      });
  };

  // ════════════════════════════════
  // API: deleteBankAccount — Bearer added
  // ════════════════════════════════
  const deleteBankAccount = (id) => {
    const formData = new FormData();
    formData.append("id", id);
    axios
      .post(`${baseUrl}/seller/bank/deleteBankAccount`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.hasOwnProperty("error")) {
          Swal.fire("Error!", data.error, "error");
        } else if (data.success == true) {
          fetchBankAccounts();
          Swal.fire("Deleted!", "Bank account deleted", "success");
        } else {
          Swal.fire("Error!", data.message, "error");
        }
      });
  };

  const validatePersonalInfo = () => {
    let valid = true;

    const nameErr = regExpChecker("username", sellerName);
    if (!sellerName) {
      setSellerNameError("Full name is required");
      valid = false;
    } else if (nameErr) {
      setSellerNameError(nameErr);
      valid = false;
    } else setSellerNameError("");

    const emailErr = regExpChecker("email", sellerEmail);
    if (!sellerEmail) {
      setSellerEmailError("Email is required");
      valid = false;
    } else if (emailErr) {
      setSellerEmailError(emailErr);
      valid = false;
    } else setSellerEmailError("");

    if (sellerPhone) {
      const phoneErr = regExpChecker("phoneNumber", sellerPhone);
      if (phoneErr) {
        setSellerPhoneError(phoneErr);
        valid = false;
      } else setSellerPhoneError("");
    } else setSellerPhoneError("");

    return valid;
  };

  // ════════════════════════════════
  // API: updatePersonalInfo — Bearer added, no kmseller_id
  // ════════════════════════════════
  const updatePersonalInfo = () => {
    const fd = new FormData();
    fd.append("name", sellerName);
    fd.append("email", sellerEmail);
    fd.append("phone", sellerPhone);
    axios
      .post(`${baseUrl}/seller/profile/updateProfile`, fd, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.success) {
          Swal.fire("Saved!", "Personal information updated successfully", "success");
          viewSellerProfile();
        } else {
          Swal.fire("Error!", data.message, "error");
        }
      })
      .catch(() => {
        Swal.fire("Error!", "Failed to update personal information", "error");
      });
  };

  const validatePasswordChange = () => {
    let valid = true;

    if (!currentPassword) {
      setCurrentPasswordError("Current password is required");
      valid = false;
    } else setCurrentPasswordError("");

    const newPassErr = regExpChecker("password", newPassword);
    if (!newPassword) {
      setNewPasswordError("New password is required");
      valid = false;
    } else if (newPassErr) {
      setNewPasswordError(newPassErr);
      valid = false;
    } else setNewPasswordError("");

    if (!confirmPassword) {
      setConfirmPasswordError("Please confirm your new password");
      valid = false;
    } else if (confirmPassword !== newPassword) {
      setConfirmPasswordError("Passwords do not match");
      valid = false;
    } else setConfirmPasswordError("");

    return valid;
  };

  // ════════════════════════════════
  // API: changePassword — Bearer added, no kmseller_id
  // ════════════════════════════════
  const changePassword = () => {
    const fd = new FormData();
    fd.append("currentPassword", currentPassword);
    fd.append("newPassword", newPassword);
    axios
      .post(`${baseUrl}/seller/profile/updatePassword`, fd, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        if (data.success) {
          Swal.fire("Changed!", "Password changed successfully", "success");
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
        } else {
          Swal.fire("Error!", data.message, "error");
        }
      })
      .catch(() => {
        Swal.fire("Error!", "Failed to change password", "error");
      });
  };

  // ════════════════════════════════
  // API: changeNotificationSetting (naya) — Bearer, no kmseller_id
  // ════════════════════════════════
  const changeNotificationSetting = () => {
    setSavingPreferences(true);
    const fd = new FormData();
    fd.append("emailNotification", emailNotification ? 1 : 0);
    fd.append("inAppNotification", inAppNotification ? 1 : 0);
    axios
      .post(`${baseUrl}/seller/profile/changeNotificationSetting`, fd, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then(({ data }) => {
        setSavingPreferences(false);
        if (data.success) {
          Swal.fire("Saved!", "Notification settings updated!", "success");
        } else {
          Swal.fire("Error!", data.message, "error");
        }
      })
      .catch(() => {
        setSavingPreferences(false);
        Swal.fire("Error!", "Failed to update notification settings", "error");
      });
  };

  const currentBankAccounts = bankAccounts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const kycStatusConfig = {
    pending: {
      label: "Pending Review",
      className: "pending",
      icon: <FaClock />,
      title: "Verification Pending",
      text: "Your documents are under review. We will notify you once verified.",
    },
    verified: {
      label: "Verified",
      className: "verified",
      icon: <FaCheckCircle />,
      title: "Verification Complete",
      text: "Your KYC has been verified. You are now a verified seller.",
    },
    rejected: {
      label: "Rejected",
      className: "rejected",
      icon: <FaTimes />,
      title: "Verification Rejected",
      text: "Your KYC was rejected. Please re-upload correct documents.",
    },
  };
  const kycStatus = kycStatusConfig[isVerified] || kycStatusConfig.pending;

  if (pageLoading) {
    return (
      <SellerLayout>
        <SellerSettingsPageSkeleton />
      </SellerLayout>
    );
  }

  return (
    <SellerLayout>
      <Container fluid className="settings-container">
        <div className="orders-header mb-4">
          <div className="orders-header-left">
            <div className="orders-icon-wrapper">
              <FiSettings size={32} />
            </div>
            <div>
              <h2 className="orders-page-title">Settings</h2>
              <p className="orders-subtitle">Manage your account and preferences</p>
            </div>
          </div>
        </div>

        <div className="sel-tabs-wrap mb-4">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`sel-tab ${activeTab === tab.id ? "sel-tab--active" : ""}`}
              onClick={() => {
                setActiveTab(tab.id);
                setShowBankForm(false);
              }}
            >
              <span className="sel-tab__icon">{tab.icon}</span>
              <span className="sel-tab__label">{tab.label}</span>
            </button>
          ))}
        </div>

        <Row className="g-4">
          {/* TAB 1 — SHOP PROFILE */}
          {activeTab === "shop-profile" && (
            <Col xs={12}>
              <Card className="settings-card">
                <Card.Body>
                  <div className="settings-header">
                    <div className="settings-header-left">
                      <div className="settings-icon-wrapper"><FaStore size={22} /></div>
                      <div>
                        <h4 className="settings-card-title">Shop Profile</h4>
                        <p className="settings-card-subtitle">Update your shop and business details</p>
                      </div>
                    </div>
                    <Button variant="gradient" icon={<FiSave size={15} />} disabled={loading}
                      onClick={() => businessDetailsId ? updateBusinessDetails() : addBusinessDetails()}>
                      {loading ? "Saving..." : "Save Changes"}
                    </Button>
                  </div>
                  <Row className="g-4 mt-1">
                    <Col xs={12} md={3}>
                      <div className="sel-logo-card">
                        <div className="sel-logo-avatar-wrap">
                          {logoPreview ? (
                            <img src={logoPreview} alt="Shop Logo" className="sel-logo-img" />
                          ) : (
                            <FaStore className="sel-logo-placeholder-icon" />
                          )}
                          <label className="sel-logo-camera-btn" title="Change Logo">
                            <FiCamera size={13} />
                            <input type="file" accept="image/*" style={{ display: "none" }}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) { setLogo(file); setLogoPreview(URL.createObjectURL(file)); }
                              }} />
                          </label>
                        </div>
                        <p className="sel-logo-shop-name">{shop_name || "Your Shop"}</p>
                        <p className="sel-logo-hint">PNG or JPG — max 2 MB</p>
                      </div>
                    </Col>
                    <Col xs={12} md={9}>
                      <Row className="g-3">
                        <Col xs={12}>
                          <Form.Group>
                            <Form.Label className="form-label">Shop Name &nbsp;<FaLock style={{ fontSize: 11, color: "var(--text-muted)" }} /></Form.Label>
                            <Form.Control type="text" value={shop_name} readOnly className="form-input seller-input-locked" />
                            <small className="seller-locked-hint">Contact support to change shop name</small>
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label className="form-label">Business Email *</Form.Label>
                            <InputGroup>
                              <InputGroup.Text className="input-icon"><FiMail /></InputGroup.Text>
                              <Form.Control
                                type="email"
                                value={businessemail}
                                placeholder="business@email.com"
                                style={businessemailError ? errBorder : undefined}
                                onChange={(e) => {
                                  setBusinessemail(e.target.value);
                                  setBusinessemailError(
                                    e.target.value ? (regExpChecker("email", e.target.value) || "") : "Business email is required"
                                  );
                                }}
                                className="form-input"
                              />
                            </InputGroup>
                            {businessemailError && <p style={errText}>{businessemailError}</p>}
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label className="form-label">Phone Number *</Form.Label>
                            <InputGroup>
                              <InputGroup.Text className="input-icon"><FiPhone /></InputGroup.Text>
                              <Form.Control
                                type="tel"
                                value={phonenumber}
                                placeholder="0300-1234567"
                                style={phonenumberError ? errBorder : undefined}
                                onChange={(e) => {
                                  setPhonenumber(e.target.value);
                                  setPhonenumberError(e.target.value ? (regExpChecker("phoneNumber", e.target.value) || "") : "");
                                }}
                                className="form-input"
                              />
                            </InputGroup>
                            {phonenumberError && <p style={errText}>{phonenumberError}</p>}
                          </Form.Group>
                        </Col>
                        <Col xs={12}>
                          <Form.Group>
                            <Form.Label className="form-label">Business Address *</Form.Label>
                            <InputGroup>
                              <InputGroup.Text className="input-icon"><FiMapPin /></InputGroup.Text>
                              <Form.Control
                                type="text"
                                value={businessAddress}
                                placeholder="Enter business address"
                                style={businessAddressError ? errBorder : undefined}
                                onChange={(e) => {
                                  setBusinessAddress(e.target.value);
                                  setBusinessAddressError(e.target.value.trim() ? "" : "Business address is required");
                                }}
                                className="form-input"
                              />
                            </InputGroup>
                            {businessAddressError && <p style={errText}>{businessAddressError}</p>}
                          </Form.Group>
                        </Col>
                        <Col xs={12}>
                          <Form.Group>
                            <Form.Label className="form-label">Shop Description</Form.Label>
                            <Form.Control as="textarea" rows={3} value={sellerDescription} placeholder="Describe your shop..."
                              onChange={(e) => setSellerDescription(e.target.value)} className="form-input" />
                          </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                          <Form.Group>
                            <Form.Label className="form-label">CNIC Number &nbsp;<FaLock style={{ fontSize: 11, color: "var(--text-muted)" }} /></Form.Label>
                            <Form.Control type="text" value={cnic} readOnly className="form-input seller-input-locked" />
                            <small className="seller-locked-hint">CNIC cannot be changed once verified</small>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* TAB 2 — PERSONAL INFORMATION */}
          {activeTab === "personal-info" && (
            <Col xs={12}>
              <Card className="settings-card">
                <Card.Body>
                  <div className="settings-header">
                    <div className="settings-header-left">
                      <div className="settings-icon-wrapper"><FiUser size={22} /></div>
                      <div>
                        <h4 className="settings-card-title">Personal Information</h4>
                        <p className="settings-card-subtitle">Update your personal details</p>
                      </div>
                    </div>
                    <Button variant="gradient" icon={<FiSave size={15} />}
                      onClick={() => {
                        if (validatePersonalInfo()) updatePersonalInfo();
                      }}>
                      Save Changes
                    </Button>
                  </div>
                  <Row className="g-3 mt-2">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="form-label">Full Name *</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="input-icon"><FiUser /></InputGroup.Text>
                          <Form.Control
                            type="text"
                            value={sellerName}
                            placeholder="Enter full name"
                            style={sellerNameError ? errBorder : undefined}
                            onChange={(e) => {
                              setSellerName(e.target.value);
                              setSellerNameError(e.target.value ? (regExpChecker("username", e.target.value) || "") : "Full name is required");
                            }}
                            className="form-input"
                          />
                        </InputGroup>
                        {sellerNameError && <p style={errText}>{sellerNameError}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="form-label">Email Address *</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="input-icon"><FiMail /></InputGroup.Text>
                          <Form.Control
                            type="email"
                            value={sellerEmail}
                            placeholder="Enter email"
                            style={sellerEmailError ? errBorder : undefined}
                            onChange={(e) => {
                              setSellerEmail(e.target.value);
                              setSellerEmailError(e.target.value ? (regExpChecker("email", e.target.value) || "") : "Email is required");
                            }}
                            className="form-input"
                          />
                        </InputGroup>
                        {sellerEmailError && <p style={errText}>{sellerEmailError}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="form-label">Phone Number</Form.Label>
                        <InputGroup>
                          <InputGroup.Text className="input-icon"><FiPhone /></InputGroup.Text>
                          <Form.Control
                            type="tel"
                            value={sellerPhone}
                            placeholder="0300-1234567"
                            style={sellerPhoneError ? errBorder : undefined}
                            onChange={(e) => {
                              setSellerPhone(e.target.value);
                              setSellerPhoneError(e.target.value ? (regExpChecker("phoneNumber", e.target.value) || "") : "");
                            }}
                            className="form-input"
                          />
                        </InputGroup>
                        {sellerPhoneError && <p style={errText}>{sellerPhoneError}</p>}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* TAB 3 — BANK ACCOUNTS */}
          {activeTab === "bank-accounts" && (
            <Col xs={12}>
              {!showBankForm ? (
                <Card className="settings-card">
                  <Card.Body>
                    <div className="settings-header">
                      <div className="settings-header-left">
                        <div className="settings-icon-wrapper"><FaUniversity size={20} /></div>
                        <div>
                          <h4 className="settings-card-title">Bank Accounts</h4>
                          <p className="settings-card-subtitle">Manage your payout bank accounts</p>
                        </div>
                      </div>
                      <Button variant="gradient" icon={<FaPlus />}
                        onClick={() => {
                          setSelectedBank(null);
                          setBankName("");
                          setAccountTitle("");
                          setAccountNumber("");
                          setIsPrimary(false);
                          setBankNameError("");
                          setAccountTitleError("");
                          setAccountNumberError("");
                          setShowBankForm(true);
                        }}>
                        Add Account
                      </Button>
                    </div>

                    <div className="seller-bank-list">
                      {currentBankAccounts.length === 0 && (
                        <div className="seller-empty-state">
                          <FaUniversity className="seller-empty-icon" />
                          <p>No bank accounts added yet</p>
                        </div>
                      )}
                      {currentBankAccounts.map((account) => (
                        <div key={account.id} className="settings-item seller-bank-item">
                          <div className="settings-item-info">
                            <div className="seller-bank-name-row">
                              <FaUniversity style={{ color: "var(--secondary-color)", marginRight: 8 }} />
                              <span className="seller-bank-name">{account.bankname}</span>
                              {account.isprimary == 1 && (
                                <span className="seller-primary-badge">Primary</span>
                              )}
                            </div>
                            <div className="seller-bank-details">
                              <span>Title: <strong>{account.accounttitle}</strong></span>
                              <span>Account: <strong>{account.accountnumber}</strong></span>
                            </div>
                          </div>
                          <div className="seller-bank-actions">
                            <button className="seller-action-btn seller-action-edit"
                              onClick={() => {
                                setSelectedBank(account);
                                setBankName(account.bankname);
                                setAccountTitle(account.accounttitle);
                                setAccountNumber(account.accountnumber);
                                setIsPrimary(account.isprimary == 1);
                                setBankNameError("");
                                setAccountTitleError("");
                                setAccountNumberError("");
                                setShowBankForm(true);
                              }}>
                              <FaEdit />
                            </button>
                            <button className="seller-action-btn seller-action-delete"
                              onClick={async () => {
                                const r = await Swal.fire({
                                  title: "Delete Bank Account?",
                                  text: "This action cannot be undone",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#dc3545",
                                  cancelButtonColor: "#6b7280",
                                  confirmButtonText: "Yes, Delete",
                                });
                                if (r.isConfirmed) {
                                  deleteBankAccount(account.id);
                                }
                              }}>
                              <FaTrash />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>

                    <Pagination
                      totalItems={bankAccounts.length}
                      itemsPerPage={itemsPerPage}
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                      onItemsPerPageChange={(i) => { setItemsPerPage(i); setCurrentPage(1); }}
                    />
                  </Card.Body>
                </Card>
              ) : (
                <Card className="settings-card">
                  <Card.Body>
                    <div className="settings-header">
                      <div className="settings-header-left">
                        <div className="settings-icon-wrapper"><FaUniversity size={20} /></div>
                        <div>
                          <h4 className="settings-card-title">{selectedBank ? "Edit Bank Account" : "Add Bank Account"}</h4>
                          <p className="settings-card-subtitle">Fill in your bank account details</p>
                        </div>
                      </div>
                      <button className="seller-close-btn"
                        onClick={() => { setShowBankForm(false); setSelectedBank(null); }}>
                        <FaTimes />
                      </button>
                    </div>

                    <Row className="g-3 mt-2">
                      <Col xs={12}>
                        <Form.Group>
                          <Form.Label className="form-label">Bank Name *</Form.Label>
                          <Form.Select
                            value={bankName}
                            style={bankNameError ? errBorder : undefined}
                            onChange={(e) => {
                              setBankName(e.target.value);
                              setBankNameError(e.target.value ? "" : "Please select a bank");
                            }}
                            className="form-select-custom"
                          >
                            <option value="">Select Bank</option>
                            <option>Habib Bank Limited (HBL)</option>
                            <option>MCB Bank Limited</option>
                            <option>Allied Bank Limited</option>
                            <option>United Bank Limited (UBL)</option>
                            <option>National Bank of Pakistan</option>
                            <option>Meezan Bank</option>
                            <option>Faysal Bank</option>
                            <option>Askari Bank</option>
                            <option>Bank Alfalah</option>
                            <option>Bank Al Habib</option>
                            <option>Standard Chartered Bank</option>
                            <option>JS Bank</option>
                            <option>Soneri Bank</option>
                            <option>Summit Bank</option>
                            <option>Silk Bank</option>
                            <option>Al Baraka Bank</option>
                            <option>Dubai Islamic Bank Pakistan</option>
                            <option>Bank of Punjab</option>
                            <option>Bank of Khyber</option>
                            <option>Sindh Bank</option>
                          </Form.Select>
                          {bankNameError && <p style={errText}>{bankNameError}</p>}
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label className="form-label">Account Title *</Form.Label>
                          <Form.Control
                            type="text"
                            value={accountTitle}
                            placeholder="Enter account title"
                            style={accountTitleError ? errBorder : undefined}
                            onChange={(e) => {
                              setAccountTitle(e.target.value);
                              setAccountTitleError(e.target.value.trim() ? "" : "Account title is required");
                            }}
                            className="form-input"
                          />
                          {accountTitleError && <p style={errText}>{accountTitleError}</p>}
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group>
                          <Form.Label className="form-label">Account Number *</Form.Label>
                          <Form.Control
                            type="text"
                            value={accountNumber}
                            placeholder="Enter account number"
                            style={accountNumberError ? errBorder : undefined}
                            onChange={(e) => {
                              setAccountNumber(e.target.value);
                              const v = e.target.value.trim();
                              if (!v) setAccountNumberError("Account number is required");
                              else if (!/^[0-9]{5,}$/.test(v)) setAccountNumberError("Account number must be at least 5 digits");
                              else setAccountNumberError("");
                            }}
                            className="form-input"
                          />
                          {accountNumberError && <p style={errText}>{accountNumberError}</p>}
                        </Form.Group>
                      </Col>

                      <Col xs={12}>
                        <div className="seller-checkbox-row">
                          <Form.Check type="checkbox" id="isPrimary" checked={isPrimary}
                            onChange={(e) => setIsPrimary(e.target.checked)} />
                          <label htmlFor="isPrimary" className="seller-checkbox-label">Set as primary account</label>
                        </div>
                      </Col>
                    </Row>

                    <div className="seller-form-footer">
                      <Button variant="outline"
                        onClick={() => { setShowBankForm(false); setSelectedBank(null); }}>
                        Cancel
                      </Button>
                      <Button variant="gradient" icon={<FiSave size={15} />}
                        onClick={() => selectedBank ? updateBankAccount() : addBankAccount()}>
                        {selectedBank ? "Update Account" : "Add Account"}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              )}
            </Col>
          )}

          {/* TAB 4 — CHANGE PASSWORD */}
          {activeTab === "password" && (
            <Col xs={12} lg={12}>
              <Card className="settings-card h-100">
                <Card.Body>
                  <div className="settings-header">
                    <div className="settings-header-left">
                      <div className="settings-icon-wrapper"><FiLock size={22} /></div>
                      <div>
                        <h4 className="settings-card-title">Change Password</h4>
                        <p className="settings-card-subtitle">Keep your account secure</p>
                      </div>
                    </div>
                  </div>
                  <Row className="g-4 mt-4">
                    {[
                      { key: "current", label: "Current Password", value: currentPassword, error: currentPasswordError },
                      { key: "new", label: "New Password", value: newPassword, error: newPasswordError },
                      { key: "confirm", label: "Confirm Password", value: confirmPassword, error: confirmPasswordError },
                    ].map(({ key, label, value, error }) => (
                      <Col xs={12} key={key}>
                        <Form.Group>
                          <Form.Label className="form-label">{label} *</Form.Label>
                          <InputGroup>
                            <Form.Control
                              type={
                                (key === "current" && showCurrentPassword) ||
                                (key === "new" && showNewPassword) ||
                                (key === "confirm" && showConfirmPassword)
                                  ? "text" : "password"
                              }
                              value={value}
                              style={error ? errBorder : undefined}
                              onChange={(e) => {
                                const v = e.target.value;

                                if (key === "current") {
                                  setCurrentPassword(v);
                                  setCurrentPasswordError(v ? "" : "Current password is required");
                                } else if (key === "new") {
                                  setNewPassword(v);
                                  if (!v) setNewPasswordError("New password is required");
                                  else setNewPasswordError(regExpChecker("password", v) || "");
                                  if (confirmPassword) {
                                    setConfirmPasswordError(confirmPassword === v ? "" : "Passwords do not match");
                                  }
                                } else if (key === "confirm") {
                                  setConfirmPassword(v);
                                  if (!v) setConfirmPasswordError("Please confirm your new password");
                                  else setConfirmPasswordError(v === newPassword ? "" : "Passwords do not match");
                                }
                              }}
                              className="form-input" placeholder={label} />
                            <button type="button" className="password-toggle" onClick={() => togglePass(key)}>
                              {((key === "current" && showCurrentPassword) ||
                                (key === "new" && showNewPassword) ||
                                (key === "confirm" && showConfirmPassword))
                                ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                            </button>
                          </InputGroup>
                          {error && <p style={errText}>{error}</p>}
                        </Form.Group>
                      </Col>
                    ))}
                    <Col xs={12}>
                      <Button variant="gradient" icon={<FiLock size={16} />}
                        onClick={() => {
                          if (!validatePasswordChange()) return;
                          Swal.fire({
                            title: "Change Password?",
                            text: "You will need to login again",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#097d43",
                            cancelButtonColor: "#6b7280",
                            confirmButtonText: "Yes, Change",
                          }).then((r) => {
                            if (r.isConfirmed) {
                              changePassword();
                            }
                          });
                        }}>
                        Change Password
                      </Button>
                    </Col>
                  </Row>
                  <div className="seller-password-rules">
                    <p className="seller-password-rules-title">Password Requirements:</p>
                    <ul className="seller-password-rules-list">
                      <li>Minimum 8 characters long</li>
                      <li>At least one uppercase letter</li>
                      <li>At least one lowercase letter</li>
                      <li>At least one number</li>
                      <li>At least one special character (@, #, $, etc.)</li>
                    </ul>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* TAB 5 — KYC VERIFICATION */}
          {activeTab === "verification" && (
            <Col xs={12}>
              <Card className="settings-card">
                <Card.Body>
                  <div className="settings-header">
                    <div className="settings-header-left">
                      <div className="settings-icon-wrapper"><FiFileText size={22} /></div>
                      <div>
                        <h4 className="settings-card-title">KYC Verification</h4>
                        <p className="settings-card-subtitle">Submit documents for identity verification</p>
                      </div>
                    </div>
                    <span className={`seller-kyc-badge ${kycStatus.className}`}>{kycStatus.label}</span>
                  </div>

                  <div className={`seller-kyc-banner ${kycStatus.className}`}>
                    <div className={`seller-kyc-banner-icon ${kycStatus.className}`}>{kycStatus.icon}</div>
                    <div>
                      <p className="seller-kyc-banner-title">{kycStatus.title}</p>
                      <p className="seller-kyc-banner-text">{kycStatus.text}</p>
                    </div>
                  </div>

                  <p className="seller-section-label">Business Information</p>
                  <Row className="g-3 mb-4">
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="form-label"><FaBuilding style={{ marginRight: 6 }} />Business Name *</Form.Label>
                        <Form.Control type="text" value={shop_name} placeholder="Business name"
                          onChange={(e) => setshop_name(e.target.value)} className="form-input" />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="form-label"><FaPhone style={{ marginRight: 6 }} />Phone Number *</Form.Label>
                        <Form.Control
                          type="tel"
                          value={phonenumber}
                          placeholder="0300-1234567"
                          style={kycPhoneError ? errBorder : undefined}
                          onChange={(e) => {
                            setPhonenumber(e.target.value);
                            setKycPhoneError(e.target.value ? (regExpChecker("phoneNumber", e.target.value) || "") : "Phone number is required");
                          }}
                          className="form-input"
                        />
                        {kycPhoneError && <p style={errText}>{kycPhoneError}</p>}
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="form-label"><FaIdCard style={{ marginRight: 6 }} />CNIC Number *</Form.Label>
                        <Form.Control
                          type="text"
                          value={cnic}
                          placeholder="xxxxx-xxxxxxx-x"
                          style={kycCnicError ? errBorder : undefined}
                          onChange={(e) => {
                            setCnic(e.target.value);
                            setKycCnicError(e.target.value ? (regExpChecker("CNICnumber", e.target.value) || "") : "CNIC number is required");
                          }}
                          className="form-input"
                        />
                        {kycCnicError && <p style={errText}>{kycCnicError}</p>}
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                      <Form.Group>
                        <Form.Label className="form-label">Business Address *</Form.Label>
                        <Form.Control
                          type="text"
                          value={businessAddress}
                          placeholder="Enter business address"
                          style={kycAddressError ? errBorder : undefined}
                          onChange={(e) => {
                            setBusinessAddress(e.target.value);
                            setKycAddressError(e.target.value.trim() ? "" : "Business address is required");
                          }}
                          className="form-input"
                        />
                        {kycAddressError && <p style={errText}>{kycAddressError}</p>}
                      </Form.Group>
                    </Col>
                  </Row>

                  <p className="seller-section-label">Upload Instructions</p>
                  <Row className="g-3 mb-4">
                    {[
                      { heading: "✅ Required Documents", items: ["CNIC Front Side — Clear & readable", "CNIC Back Side — Clear & readable", "Business License / Registration", "CNIC must be valid and not expired", "All 3 documents must be included"] },
                      { heading: "📏 File Specifications", items: ["Format: PDF only", "Maximum size: 20 MB", "Combine all into single PDF", "Scan at 300 DPI recommended", "Do not password protect the PDF"] },
                    ].map(({ heading, items }) => (
                      <Col xs={12} md={6} key={heading}>
                        <div className="settings-item seller-instruction-box">
                          <div style={{ width: "100%" }}>
                            <p className="seller-instruction-heading">{heading}</p>
                            <ul className="seller-instruction-list">
                              {items.map((i) => <li key={i}>{i}</li>)}
                            </ul>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>

                  <p className="seller-section-label">Upload Document</p>
                  <div className="settings-item seller-upload-row mb-4">
                    <div className="seller-upload-left">
                      <FaFileAlt style={{ fontSize: "1.5rem", color: "var(--secondary-color)", flexShrink: 0 }} />
                      <div>
                        <p className="seller-upload-filename">{kycFileName || "No file selected"}</p>
                        <p className="seller-upload-sub">
                          {kycFileName ? `${kycFileSize} MB — PDF` : "Upload a single PDF (max 20MB) with all required documents"}
                        </p>
                      </div>
                    </div>
                    <label className="edit-btn" style={{ cursor: "pointer", flexShrink: 0 }}>
                      <FaUpload size={13} /> Upload PDF
                      <input type="file" accept="application/pdf" style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setDocuments(file);
                            setKycFileName(file.name);
                            setKycFileSize((file.size / (1024 * 1024)).toFixed(2));
                            setKycDocumentsError("");
                          }
                        }} />
                    </label>
                  </div>
                  {kycDocumentsError && <p style={errText}>{kycDocumentsError}</p>}

                  <p className="seller-section-label">Verification Process</p>
                  <div className="seller-timeline mb-4">
                    {[
                      { num: 1, title: "Upload Documents", desc: "Upload your PDF with all required documents" },
                      { num: 2, title: "Under Review", desc: "Our team verifies documents in 2–3 business days" },
                      { num: 3, title: "Verification Complete", desc: "You receive an email notification once approved" },
                    ].map((step) => (
                      <div key={step.num} className="seller-timeline-item">
                        <div className="seller-timeline-num">{step.num}</div>
                        <p className="seller-timeline-title">{step.title}</p>
                        <p className="seller-timeline-desc">{step.desc}</p>
                      </div>
                    ))}
                  </div>

                  <div className="seller-kyc-submit">
                    <Button variant="gradient" icon={<FiSave size={15} />}
                      disabled={loading || isVerified === "verified"}
                      onClick={() => {
                        if (!validateKyc()) return;
                        Swal.fire({
                          title: "Submit for Verification?",
                          html: `<div style="text-align:left;padding:1rem;">
                            <p><strong>Please ensure:</strong></p>
                            <ul style="text-align:left;">
                              <li>✅ All personal information is correct</li>
                              <li>✅ Business details are accurate</li>
                              <li>✅ PDF file is uploaded with all documents</li>
                            </ul>
                            <p style="margin-top:1rem;color:#6b7280;">Verification takes 2–3 business days</p>
                          </div>`,
                          icon: "question",
                          showCancelButton: true,
                          confirmButtonColor: "#097d43",
                          cancelButtonColor: "#6b7280",
                          confirmButtonText: "Yes, Submit",
                        }).then((r) => { if (r.isConfirmed) uploadKycDocuments(); });
                      }}>
                      {loading ? "Submitting..." : "Submit for Verification"}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* TAB 6 — NOTIFICATIONS (naya) */}
          {activeTab === "notifications" && (
            <Col xs={12} lg={12}>
              <Card className="settings-card">
                <Card.Body>
                  <div className="settings-header">
                    <div className="settings-header-left">
                      <div className="settings-icon-wrapper"><FiBell size={22} /></div>
                      <div>
                        <h4 className="settings-card-title">Notification Preferences</h4>
                        <p className="settings-card-subtitle">Choose how you want to be notified</p>
                      </div>
                    </div>
                  </div>

                  <div className="profile-notif-list">
                    <div className="profile-notif-item">
                      <div className="profile-notif-info">
                        <p className="profile-notif-label">Email Notifications</p>
                        <p className="profile-notif-desc">Receive updates and alerts via email</p>
                      </div>
                      <Form.Check
                        type="switch"
                        className="custom-switch"
                        checked={emailNotification}
                        onChange={() => setEmailNotification(!emailNotification)}
                      />
                    </div>

                    <div className="profile-notif-item">
                      <div className="profile-notif-info">
                        <p className="profile-notif-label">In App</p>
                        <p className="profile-notif-desc">Get in-app notifications</p>
                      </div>
                      <Form.Check
                        type="switch"
                        className="custom-switch"
                        checked={inAppNotification}
                        onChange={() => setInAppNotification(!inAppNotification)}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <Button
                      variant="gradient"
                      icon={<FiSave size={15} />}
                      onClick={() => changeNotificationSetting()}
                      disabled={savingPreferences}
                    >
                      {savingPreferences ? "Saving..." : "Save Preferences"}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </SellerLayout>
  );
};

export default SellerSettings;
